import styled from "styled-components";

export const Container = styled.header`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.blue400};
  padding-top: 16px;
  padding-bottom: 16px;
  z-index: 30; 
`